import React, { useEffect, useState } from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import AddressTile from '../components/AddressTile'
import Addaddress from '../components/Addaddress'
import { Url } from '../services/Constants'
import { setHeader } from '../services/Headers'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import { Getauth } from '../services/Auth';


export default function Address() {


  const Navigate = useNavigate()


  const [isAddaddress,setIsAddaddress] = useState(false)
  const [addressData, setAddressData] = useState([])
  const [reloding, setReloding] = useState(false)
  const [profile, setProfile] = useState()


  useEffect(()=>{
    async function checkprelogin() {
      if(Getauth){
        try {
          const result = await axios.get(`${Url}/buyer/get_profile`, setHeader())
          setProfile(result.data.response_data)
          if(result.data.response_code===200){
            try {
              const addressResult = await axios.get(`${Url}/buyer/addresses`, setHeader())
              const a = await addressResult.data.response_data.addresses
              setAddressData(a)
            } catch (error) {
              console.log(error)
            }
          }
          else{
            Navigate("/")
          }
        } catch (error) {
          console.log(error)
        }
        }else{
          Navigate("/")
        }
      }
    
    checkprelogin()
  },[reloding])


  
  const relodeHandle =()=>{
    setReloding(!reloding)
  }



  const isAddressToggle=() =>{
    setIsAddaddress(!isAddaddress)
  }


  return (
    <>
    <div className="address-container z-20 relative">
    <div className="address-top ">
      <Navbar/>
    </div>
    <div className="address-feed pb-[1%] relative bg-slate-100 w-[70%] mx-auto rounded-2xl z-10 top-28 mb-40 shadow-xl">
    <div className="feed-title w-[96%] border-b-2 py-[1%] mx-auto text-center border-b-amber-950 ">
      <span className="text-amber-950 font-bold text-2xl">Address Book</span>
    </div>
    <div className="add-btn-container w-[96%] mx-auto flex justify-end ">
    <div className="add-button w-[40%] md:w-[15%] py-[0.5%] mt-[1.5%] bg-amber-950 text-white text-center rounded-lg cursor-pointer" onClick={()=>setIsAddaddress(!isAddaddress)}>Add Address</div>
    </div>
    <div className="feed-container w-[96%] my-[2%] mx-auto">
    {addressData.length!==0?addressData.map((item)=>(<AddressTile data={{profile,item,relodeHandle}} key={item.id} />)):
    <div className='h-screen'>
    "NO address found!"
    </div>}
    </div>
    </div>
    <div className="address-bottom mb-0">
      <Footer/>
    </div>
  </div>

    {/* <Addaddress/> */}
  {isAddaddress?<Addaddress data={isAddressToggle}/>:""}
  </>
  )
}
